<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="mainContentFullWith">
  <mat-tab-group [selectedIndex]="selectedIndex">
    <mat-tab label="{{translation.VehicleSelection}}" disabled class="unselectable row">
      <div class="unselectable headerTitle headline">{{translation.AddNewDamageReport}}</div>
      <div class="gridParentContainer">
        <ejs-grid #damageCaseGrid class="responsiveGrids"
                  (rowSelected)="damageCaseRowSelect($event)"
                  [locale]="locale"
                  [toolbar]="toolbar"
                  (toolbarClick)="toolbarClick($event)"
                  [dataSource]="damageCaseDataSource"
                  [columns]="damageCaseOptions">
        </ejs-grid>
      </div>
    </mat-tab>
    <mat-tab label="{{translation.DamageReport}}" disabled class="unselectable">
      <div class="damageCaseContainer">
        <div class="damageCaseInfos">
          <mat-card class="damageCaseCardLeft">
            <mat-card-title class="damageCaseCardTitle">{{translation.OrderInformations}}</mat-card-title>
            <mat-card-content class="damageCaseCardContent" *ngIf="!differentVehicle">
              <mat-card-subtitle class="addressLine">{{translation.Transport}}-ID: {{damageCase.TransitId}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.Sender}}: {{damageCase.SenderDisplayName}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.Recipient}}: {{damageCase.ReceiverDisplayName}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.Status}}: {{deliveryState}}</mat-card-subtitle>
            </mat-card-content>
             <mat-card-content class="damageCaseCardContent" *ngIf="differentVehicle">
              <mat-card-subtitle class="addressLine">
                <mat-form-field class="w-100">
                  <mat-label>{{translation.Sender}}</mat-label>
                  <input matInput [(ngModel)]="damageCase.OriginalSender">
                </mat-form-field>
              </mat-card-subtitle>
              <mat-card-subtitle class="addressLine">
                <mat-form-field class="w-100">
                  <mat-label>{{translation.Recipient}}</mat-label>
                  <input matInput [(ngModel)]="damageCase.OriginalRecipient">
                </mat-form-field>
              </mat-card-subtitle>
              <mat-card-subtitle class="addressLine">
                <mat-form-field class="w-100">
                  <mat-label>{{translation.Reference}}</mat-label>
                  <input matInput [(ngModel)]="damageCase.Identification">
                </mat-form-field>
              </mat-card-subtitle>
            </mat-card-content>
          </mat-card>
          <mat-card class="damageCaseCardRight">
            <mat-card-title class="damageCaseCardTitle">{{translation.VehicleInformation}}</mat-card-title>
            <mat-card-content class="damageCaseCardContent" *ngIf="!differentVehicle">
              <mat-card-subtitle class="addressLine">{{translation.Vehicle}}: {{damageCase.CarTypeDisplayName}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.ChassisNumber}}: {{damageCase.ChassisNo}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.Mark}}: {{damageCase.License}}</mat-card-subtitle>
              <mat-card-subtitle class="addressLine">{{translation.Reference}}: {{damageCase.Identification}}</mat-card-subtitle>
            </mat-card-content>
            <mat-card-content class="damageCaseCardContent" *ngIf="differentVehicle">
              <mat-card-subtitle class="addressLine">
                <mat-form-field class="w-100">
                  <mat-label>{{translation.Vehicle}}</mat-label>
                  <input matInput [(ngModel)]="damageCase.OriginalModel">
                </mat-form-field>
              </mat-card-subtitle>
              <mat-card-subtitle class="addressLine">
                <mat-form-field class="w-100">
                  <mat-label>{{translation.ChassisNumber}}</mat-label>
                  <input matInput [(ngModel)]="damageCase.ChassisNo">
                </mat-form-field>
              </mat-card-subtitle>
              <mat-card-subtitle class="addressLine">
                <mat-form-field class="w-100">
                  <mat-label>{{translation.Mark}}</mat-label>
                  <input matInput [(ngModel)]="damageCase.License">
                </mat-form-field>
              </mat-card-subtitle>
            </mat-card-content>
          </mat-card>
        </div>
        <form id="damageCaseForm" class="row">
          <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
            <mat-form-field class="formField">
              <input #senderDateInput name="senderDate" matInput [matDatepicker]="picker" placeholder="{{translation.DamageDate}}" [(ngModel)]="tempDate" [min]="minDate" [max]="maxDate" (focus)="openDatePicker(picker)" (click)="openDatePicker(picker)" required>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
            <mat-form-field class="formField">
              <mat-select placeholder="{{translation.Time}}" name="damageTime" required [(ngModel)]="damageCase.DamageTime">
                <mat-option *ngFor="let time of timeSelects" [value]="time">{{time}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
            <mat-form-field class="formField">
              <mat-label>{{translation.CostEstimate}}</mat-label>
              <input matInput name="costEstimate" [(ngModel)]="damageCase.CostEstimate" type="number" class="rightAlign">
              <span matSuffix>&nbsp;CHF</span>
            </mat-form-field>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 damageButtonContainer">
            <label for="hiddenButton"><i class="bi bi-file-earmark-text"></i> {{translation.AddFile}}</label>
            <input id="hiddenButton" type="file" class="whiteText hiddenButton" mat-button (change)="onCostEstimateFileSelected($event)">
          </div>
          <div class="col-12" *ngIf="damageCase.DamageDocuments.length > 0">
            <mat-card class="damageCard" *ngFor="let document of damageCase.DamageDocuments">
              <mat-card-title class="damageCaseCardTitle">{{translation.Documents}}</mat-card-title>
              <div class="row damageRow" *ngIf="document.DocumentType === '0'">
                <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3 d-flex align-items-center">
                  <mat-form-field class="w-100">
                    <mat-label>{{translation.DocumentType}}</mat-label>
                    <input matInput readonly [value]="translation.CostEstimate">
                  </mat-form-field>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3 d-flex align-items-center">
                  <mat-form-field class="w-100">
                    <mat-label>{{translation.FileName}}</mat-label>
                    <input matInput readonly [value]="document.FileName">
                  </mat-form-field>
                </div>
                <div class="col-xs-11 col-sm-11 col-md-5 col-lg-5 imageContainer">
                  <img [src]="IsImage(document.Base64String) ? document.Base64String : './../../../../assets/images/file.svg'" (click)="onPreviewClick(document.Base64String)">
                </div>
                <div class="col-1 damageButtonContainer">
                  <button type="button" class="whiteText" mat-button (click)="removeCostEstimateFile()"><i class="bi bi-trash"></i></button>
                </div>
              </div>
            </mat-card>
          </div>
          <div class="col-12" *ngIf="damageCase.Damages">
            <mat-card class="damageCard" *ngIf="damageCase.Damages.length > 0">
              <mat-card-title class="damageCaseCardTitle">{{translation.Damages}}</mat-card-title>
              <mat-card-content>
                <div class="row damageRow" *ngFor="let damage of damageCase.Damages">
                <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>{{translation.DamageArea}}</mat-label>
                    <input matInput readonly [value]="getDamageAreaDescription(damage.AreaId)">
                  </mat-form-field>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                  <mat-form-field class="w-100">
                    <mat-label>{{translation.DamageType}}</mat-label>
                    <input matInput readonly [value]="getDamageTypeDescription(damage.TypeId)">
                  </mat-form-field>
                </div>
                <div class="col-xs-11 col-sm-11 col-md-5 col-lg-5 imageContainer">
                  <img *ngFor="let img of damage.Images | slice:0:4" [src]="img.Base64" (click)="onPreviewClick(img.Base64)">
                </div>
                <div class="col-1 damageButtonContainer">
                  <button type="button" class="whiteText" mat-button (click)="removeDamage(damage)"><i class="bi bi-trash"></i></button>
                </div>
              </div>
              </mat-card-content>
            </mat-card>
            <mat-card class="damageCard">
              <mat-card-content>
              <div class="row" *ngIf="!damage.InEdit">
                <div class="col-12 damageButtonContainer d-flex justify-content-center">
                  <button type="button" class="whiteText" mat-button (click)="this.damage.InEdit = true"><i class="bi bi-plus-circle"></i> {{translation.AddDamage}}</button>
                </div>
              </div>
              <div class="row" *ngIf="damage.InEdit">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <mat-form-field class="w-100">
                    <mat-select [placeholder]="translation.DamageArea" [readonly]="!damage.InEdit" [(ngModel)]="damage.AreaId" [ngModelOptions]="{standalone: true}">
                      <mat-option *ngFor="let damageArea of damageAreas" [value]="damageArea.Id">
                        {{damageArea.Code}} - {{damageArea.DescriptionDE}}
                      </mat-option>
                    </mat-select> 
                  </mat-form-field>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <mat-form-field class="w-100">
                    <mat-select [placeholder]="translation.DamageType" [readonly]="!damage.InEdit" [(ngModel)]="damage.TypeId" [ngModelOptions]="{standalone: true}">
                      <mat-option *ngFor="let damageType of damageTypes" [value]="damageType.Id">
                        {{damageType.Code}} - {{damageType.DescriptionDE}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" *ngIf="damage.InEdit">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 imageContainer">
                  <img *ngFor="let img of damage.Images | slice:0:4" [src]="img.Base64" (click)="onPreviewClick(img.Base64)">
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 damageButtonContainer">
                  <button type="button" class="whiteText" mat-button (click)="saveDamage()"><i class="bi bi-floppy"></i> {{translation.Save}}</button>
                  <button type="button" class="whiteText" mat-button (click)="cancelDamage()"><i class="bi bi-x-square"></i> {{translation.Cancel}}</button>
                  <div class="damageButtonContainer">
                    <label for="hiddenButton2"><i class="bi bi-file-image"></i> {{translation.AddImagesMaxFour}}</label>
                    <input id="hiddenButton2" type="file" class="whiteText hiddenButton" hidden multiple="true" accept="image/*" (change)="onDamageFilesSelected($event)" [readonly]="!damage.InEdit">
                  </div>
                </div>
              </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="col-6 buttonContainer">
            <button type="button" class="whiteText" mat-button (click)="goBack()">{{translation.Back}}</button>
          </div>
          <div class="col-6 justify-content-end buttonContainer">
            <button type="button" class="whiteText" mat-button (click)="validateAndSend()">{{translation.Send}}</button>
          </div>
        </form>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<app-footer></app-footer>
